var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(!_vm.routesToHide.includes(this.$router.currentRoute.path))?_c('mainNav'):_vm._e(),(this.$route.name == 'frontendPackages')?_c('frontendHeader'):_vm._e(),_c('v-main',[_c('router-view')],1),(this.$route.name == 'frontendPackages')?_c('frontendFooter'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }